import { useEffect, useState, useMemo } from "react";
import { toast } from "react-toastify";
import moment from "moment";
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import FormDrawer from "components/__new/common/form-drawer";
import { ReactComponent as IconInfo } from 'assets/images/icons/project-icons/information-new.svg'
import { ReactComponent as IconCalender03 } from "assets/images/icons/calendar-03.svg";
import { ButtonLoader, Input, SelectInput } from "components/__new/common/form";
import validate from "utils/validate";
import useLoginInfo from "hooks/useLoginInfo";
import successGif from "assets/images/icons/success-green.gif";
import Maybe from "components/__new/common/Maybe";
import PayrollDatePicker from "./PayrollDatePicker";
import * as payrollAction from "store/entities/payroll/runPayroll/action";
import * as payrollSetupAction from "store/entities/payroll/payrollSetup/action";
import Select from 'react-select';
import useUrlQueryParams from "hooks/useUrlQueryParams";
import processParams from "utils/processParams";
import { REGEX_VALUES } from "utils/regexValues";

   
const multiSelectStyles = {
    container: (base) => ({
        ...base,
        marginBottom: "1.25rem"
    }),
    control: (base, state) => ({
        ...base,
        minHeight: "2.5rem",
        borderRadius: "0.5rem",
        borderColor: "rgba(209, 213, 219, 1)",
        boxShadow: state.isFocused ? 'rgba(0, 103, 112, 1)' : 'none',
        borderColor: state.isFocused ? 'rgba(0, 103, 112, 1)' : base.borderColor,
        borderWidth: state.isFocused ? "2px" : base.borderWidth,
        '&:hover': {
            borderColor: state.isFocused ? 'rgba(0, 103, 112, 1)' : base.borderColor,
        },
    }),
    option: (base, state) => ({
        ...base,
        // backgroundColor: state.isFocused ? 'lightblue' : base.backgroundColor,
        // color: state.isFocused ? 'blue' : base.color,
    }),
    placeholder: (base) => ({
        ...base,
        fontSize: 14,
        color: '#354255',
    }),
    dropdownIndicator: (base) => ({
        ...base,
        paddingRight: 10,
        
        "> svg": {
            fill: "#718096",
            width: 20,
            height: 20,
            transform: 'scale(0.8)',
            transformOrigin: 'center',
        }
    }),
    clearIndicator: (base) => ({
        ...base,
        display: "none"
    }),
    indicatorSeparator: (base) => ({
        ...base,
        display: 'none',
    }),
    valueContainer: (base) => ({
       ...base,
       padding: "5px 8px", 
    }),
    multiValue: (base) => ({
        ...base,
        backgroundColor: '#F3F4F6',
        borderRadius: 8,
        padding: "4px 8px",
        marginRight: 10,
    }),
    multiValueLabel: (base) => ({
        ...base,
        color: '#374151',
        fontWeight: 500,
        fontSize: 14,
    }),
    multiValueRemove: (base) => ({
        ...base,
        color: 'rgba(239, 68, 68, 0.8)',
        ':hover': {
            backgroundColor: '',
            color: 'rgba(239, 68, 68, 1)',
        },
        '> svg': {
            width: 20,
            height: 20, 
            transform: 'scale(0.8)',
            transformOrigin: 'center',
        },
    }),
};

const CreatePayroll = (props) => {
    const location = useLocation();
    const {userInfo} = useLoginInfo();
    const {urlQueryParams} = useUrlQueryParams();
    const {isOpen, setIsOpen, dashboardLoading, dashboard} = props;
    const dispatch = useDispatch();
    const {
        createPayrollLoading, 
        createPayroll,
    } = useSelector((s) => s.entities.runPayroll);
    const { 
        getPayScheduleData: paySchedules,
        getPayGroupData: payGroupsData,
    } = useSelector(state => state.entities.payrollSetup);
    const [isFormValidated, setIsFormValidated] = useState(true);
    const [isAccountSuccessOpen, setIsAccountSuccessOpen] = useState(false);
    const [form, setForm] = useState({
        payrollName: "",
        // paySelection: "",
        payScheduleId: "",
        payGroup: [],
        payrollType: "NET",
        monthYear: {
            month: "",
            monthIndex: "",
            year: "",
            fullDate: null,
        },
    })
    const [listParams, setListParams] = useState({
        "page": 1,
        "per_page": 20,
    });
    const history = useHistory()
    // const { createAccountLoading } = useSelector((s) => s.auth.user);
    const [isCreatePayrollLoading, setIsCreatePayrollLoading] = useState(false);

    const payScheduleOptions = useMemo(() => {
        if (!paySchedules?.data) return [];
        
        return paySchedules?.data?.map((paySchedule) => ({
            label: paySchedule?.name,
            value: paySchedule?.id,
        }));
    }, [paySchedules]);
    
    const payGroupOptions = useMemo(() => {
        if (!payGroupsData?.data) return [];
        
        return payGroupsData?.data?.map((payGroup) => ({
            label: payGroup?.name,
            value: payGroup?.id,
        }));
    }, [payGroupsData]);

    const checkFormValidation = (data = form, appendKey, appendValue) => {
        let params = {...data};
        if (appendKey){ params = {...params, [appendKey]: appendValue}; }
        const errors = validate(params);
        if (errors){
            setIsFormValidated(false);
        }
        else{
            setIsFormValidated(true);
        }
    }
    
    const renderMonthContent = (month, shortMonth, longMonth) => {
        const tooltipText = `Tooltip for month: ${longMonth}`;
        return <span title={tooltipText}>{shortMonth}</span>;
    };
    
    const monthYearSelection = (date) => {
        if (date && date !== ""){
            const data = {
                month: moment(date).format('MMMM'),
                monthIndex: moment(date).format('M'),
                year: moment(date).format('yy'),
                fullDate: date,
            }
            setForm({...form, monthYear: data})
        }
        else{
            setForm({
                ...form,
                monthYear: {
                    month: "",
                    monthIndex: "",
                    year: "",
                    fullDate: null,
                }
            })
        }
    };

    const getPaySchedules = () => {
        dispatch(payrollSetupAction.getPaySchedule());
    }
    
    const getPayGroups = () => {
        dispatch(payrollSetupAction.getPayGroups());
    }

    const submitForm = async (e) => {
        e.preventDefault();
        const errors = validate(form);
        if (errors){
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return;
        }
        else{
            // Dispatch create account to store
            // dispatch(auth.loginUser(form.email, form.password));
            // setIsCreatePayrollLoading(true);
            // setIsOpen(false);
            // setIsCreatePayrollLoading(false)
            
            const formattedData = {
                type: form.payrollType,
                month: +form.monthYear.monthIndex,
                pay_selection: "PAY_GROUPS",
                pay_group_ids: form.payGroup.map((payGroup) => payGroup?.value || ""),
                payroll_schedule_id: form.payScheduleId,
                name: form.payrollName,
                year: +form.monthYear.year,
            }
            // dispatch(payrollAction.createPayroll(form));
            dispatch(payrollAction.createPayroll(formattedData));
        }
    }

    useEffect(() => {
        checkFormValidation();
    }, [form])
    
    useEffect(() => {
        getPaySchedules();
        getPayGroups();
        // eslint-disable-next-line
    }, [location]);
    
    useEffect(() => {
        if (createPayroll[0] !== undefined){
            setIsAccountSuccessOpen(true);
            setIsOpen(false);
        }
        // eslint-disable-next-line
    }, [createPayroll]);
    

    return (
        <>
            <Maybe condition={isAccountSuccessOpen === true}>
                <FormDrawer display="center" size="lg" isOpen={isAccountSuccessOpen} setIsOpen={setIsAccountSuccessOpen}>
                    <div className="p-6">
                        <div className="flex justify-center">
                            <div className="h-48 sm:h-56">
                                <img src={successGif} alt="Success" className="h-full object-contain mx-auto" />
                            </div>
                        </div>

                        <div className="mt-4 py-2">
                            <div className="text-center text-[#4A5564] font-normal text-lg">
                                Payroll Successfully Created
                            </div>
                        </div>

                        <div className="py-2 mt-4 flex justify-center gap-6">
                            <button type="button" className="btn btn-lg btn-block rounded-lg whitespace-nowrap text-white bg-ep-primary-600" onClick={() => {
                                setIsAccountSuccessOpen(false);
                                history.push("/payroll/" + createPayroll[0]?.id + "/run");
                                dispatch(payrollAction.resetCreatePayroll());
                            }}>
                                Close
                            </button>
                        </div>
                    </div>
                </FormDrawer>
            </Maybe>

            <FormDrawer display="center" size="lg" isOpen={isOpen} setIsOpen={setIsOpen}>
                <div className="p-6">
                    <FormDrawer.Title
                        title="Create Payroll"
                        description="Create and configure your payroll per schedule with the predefined pay period."
                        showCloseButton={true}
                        close={setIsOpen}
                    />

                    <hr className="w-full h-px mt-2 bg-[#E2E4E8] border-none" />

                    <form onSubmit={submitForm}>
                        <div className="mt-4">
                            <Input
                                type="text"
                                label="Payroll Name"
                                placeholder="Enter Payroll Name"
                                value={form.payrollName || ""}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    if (!REGEX_VALUES.LETTERS_WITH_NUMBERS_AND_HYPHEN_ONLY.test(value) || value.length > 50) {
                                        return;
                                    }
                                    setForm({...form, payrollName: value})
                                }}
                                required
                                validationName="payrollName"
                                checkFormValidation={checkFormValidation}
                            />

                            <PayrollDatePicker
                                label="Payroll Date"
                                required
                                selected={form?.monthYear?.fullDate}
                                renderMonthContent={renderMonthContent}
                                rightIcon={<div className='pr-2'>{<IconCalender03 />}</div>}
                                placeholderText="Select Payroll Month and Year"
                                onChange={(date) => monthYearSelection(date)}
                            />

                            <SelectInput
                                label="Pay Schedule"
                                value={form.payScheduleId || ""}
                                required
                                validationName="payScheduleId"
                                checkFormValidation={checkFormValidation}
                                onChange={(e) => setForm({...form, payScheduleId: e.target.value})}
                            >
                                <option value="">Select Pay Schedule</option>
                                {
                                    payScheduleOptions?.map((paySchedule) => (
                                        <option value={paySchedule?.value || ""} key={paySchedule?.value}>
                                            {paySchedule?.label || ""}
                                        </option>
                                    ))
                                }
                            </SelectInput>
                            {/* <SelectInput
                                label="Pay Selection"
                                value={form.paySelection || ""}
                                validationName="paySelection"
                                checkFormValidation={checkFormValidation}
                                onChange={(e) => setForm({...form, paySelection: e.target.value})}
                            >
                                <option value="">Select Pay Selection</option>
                                <option value="PAY_GROUPS">Pay Groups</option>
                                <option value="ALL_EMPLOYEES">All Employees</option>
                            </SelectInput> */}

                            <div className="form-group mb-1">
                                <label>Pay Group <span className="form-input-required">*</span></label>
                            </div>
                            <Select
                                isMulti
                                name="payGroup"
                                options={payGroupOptions}
                                classNamePrefix="select"
                                onChange={(selected) => {
                                    setForm({
                                        ...form,
                                        payGroup: [...selected],
                                    })
                                }}
                                required
                                styles={multiSelectStyles}
                                placeholder="Select Pay Groups"
                                noOptionsMessage={() => "No Pay Groups Left"}
                            />

                            <SelectInput
                                label="Payroll Type"
                                required
                                value={form.payrollType || ""}
                                onChange={(e) => setForm({...form, payrollType: e.target.value})}
                            >
                                <option value="">Select Type</option>
                                <option value="NET">Net Payroll</option>
                                {/* <option value="GROSS">Gross Payroll</option> */}
                            </SelectInput>

                            <div className="mt-5 flex items-center justify-end space-x-3">
                                <div>
                                    <button type="submit" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white"
                                        onClick={() => setIsOpen(false)}
                                        >
                                        Cancel
                                    </button>
                                </div>
                                <div>
                                    <ButtonLoader 
                                        type="submit" 
                                        loading={createPayrollLoading} 
                                        disabled={!isFormValidated}
                                        className="btn btn-lg w-full rounded-lg whitespace-nowrap text-white border border-ep-primary-600 bg-ep-primary-600"
                                    >
                                        Create Payroll
                                    </ButtonLoader>
                                </div>

                            </div>
                        </div>
                    </form>
                </div>
            </FormDrawer>
        </>
    )
}


export default CreatePayroll;